/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Failed_To_Parse_Csv_FileInputs */

const en_toast_failed_to_parse_csv_file = /** @type {(inputs: Toast_Failed_To_Parse_Csv_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed to parse CSV file`)
};

const nl_toast_failed_to_parse_csv_file = /** @type {(inputs: Toast_Failed_To_Parse_Csv_FileInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fout bij het parseren van CSV-bestand`)
};

/**
* | output |
* | --- |
* | "Failed to parse CSV file" |
*
* @param {Toast_Failed_To_Parse_Csv_FileInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const toast_failed_to_parse_csv_file = /** @type {((inputs?: Toast_Failed_To_Parse_Csv_FileInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Failed_To_Parse_Csv_FileInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_toast_failed_to_parse_csv_file(inputs)
	return en_toast_failed_to_parse_csv_file(inputs)
});